"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogFullScreen = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _logging = require("../../logging.js");
var _index = require("../../styles/index.js");
var _index2 = require("../Icon/icons/IconX/index.js");
var _Body = require("./Body.js");
var _BodyTitle = require("./BodyTitle.js");
var _CloseButton = require("./CloseButton.js");
var _Container = require("./Container.js");
var _Footer = require("./Footer.js");
var _FooterNav = require("./FooterNav.js");
var _Header = require("./Header.js");
var _HeaderNav = require("./HeaderNav.js");
var _HeaderTitle = require("./HeaderTitle.js");
var _Subtitle = require("./Subtitle.js");
var _excluded = ["banner", "body", "bodyProps", "bodyStyle", "bodyTitle", "dialogTitle", "id", "footer", "navStepper", "onClose", "onEscape", "className", "colorSet", "aria-label", "subtitle", "hasFooterStyleReset"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * DialogFullScreen is a fullscreen view and is used when there's a lot of information or several steps within one Dialog.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-dialogfullscreen--docs) |
 * [Encore site](https://encore.spotify.net/web/components/dialog#full-screen-dialogs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/DialogFullScreen) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=0-1208&t=Z5BWCDIk9FWsydIa-1)
 */
var DialogFullScreen = exports.DialogFullScreen = /*#__PURE__*/_react["default"].forwardRef(function DialogFullScreen(_ref, ref) {
  var banner = _ref.banner,
    body = _ref.body,
    bodyProps = _ref.bodyProps,
    bodyStyle = _ref.bodyStyle,
    bodyTitle = _ref.bodyTitle,
    dialogTitle = _ref.dialogTitle,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'encore-web-dialog-fullscreen' : _ref$id,
    footer = _ref.footer,
    navStepper = _ref.navStepper,
    onClose = _ref.onClose,
    onEscape = _ref.onEscape,
    className = _ref.className,
    _ref$colorSet = _ref.colorSet,
    colorSet = _ref$colorSet === void 0 ? 'base' : _ref$colorSet,
    _ref$ariaLabel = _ref['aria-label'],
    ariaLabel = _ref$ariaLabel === void 0 ? 'Close' : _ref$ariaLabel,
    subtitle = _ref.subtitle,
    hasFooterStyleReset = _ref.hasFooterStyleReset,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (navStepper) {
    (0, _logging.deprecatedPropWarning)('navStepper', 'DialogFullScreen', 'For stepped flows, use the `subtitle` prop with text (for mobile or desktop) or a `NavStepper` (desktop only).');
  }
  (0, _react.useEffect)(function () {
    var onKeydown = function onKeydown(event) {
      if ((event.keyCode === 27 || event.code === 'Escape') && onEscape) {
        onEscape(event);
      }
    };
    window.addEventListener('keydown', onKeydown, true);
    return function cleanup() {
      window.removeEventListener('keydown', onKeydown, true);
    };
  });
  var titleId = id && "".concat(id, "-title");
  return /*#__PURE__*/_react["default"].createElement(_Container.Container, Object.assign({
    ref: ref,
    className: (0, _index.addColorSet)(colorSet, className),
    "aria-labelledby": titleId,
    $colorSet: colorSet
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.DialogFullScreen
  }), banner, dialogTitle && /*#__PURE__*/_react["default"].createElement(_Header.Header, {
    $colorSet: colorSet
  }, /*#__PURE__*/_react["default"].createElement(_HeaderTitle.HeaderTitle, null, dialogTitle), subtitle && /*#__PURE__*/_react["default"].createElement(_Subtitle.Subtitle, null, subtitle), navStepper && /*#__PURE__*/_react["default"].createElement(_HeaderNav.HeaderNav, null, navStepper), onClose && /*#__PURE__*/_react["default"].createElement(_CloseButton.CloseButton, {
    onClick: onClose,
    "aria-label": ariaLabel,
    iconOnly: _index2.IconX,
    type: "button"
  })), /*#__PURE__*/_react["default"].createElement(_Body.Body, Object.assign({
    style: bodyStyle
  }, bodyProps), bodyTitle && /*#__PURE__*/_react["default"].createElement(_BodyTitle.BodyTitle, {
    id: titleId
  }, bodyTitle), body), (navStepper || footer) && /*#__PURE__*/_react["default"].createElement(_Footer.Footer, {
    $colorSet: colorSet,
    $hasFooterStyleReset: hasFooterStyleReset,
    "data-testid": "dialog-footer"
  }, navStepper && /*#__PURE__*/_react["default"].createElement(_FooterNav.FooterNav, null, navStepper), footer));
});